import { NotFound } from '~/shared/ui/NotFound'

function NotFoundPage() {
  return <NotFound />
}

export default NotFoundPage
